export default "__VITE_ASSET__C7g6eEi___"